import { type FC, useCallback } from 'react';

import { Link } from '@vakantiesnl/components/src/atoms/Link';
import { Typography } from '@vakantiesnl/components/src/atoms/Typography';

import { useStyles } from './HeaderDescription.style';

interface Props {
	description: string;
	readMoreRef: React.RefObject<HTMLDivElement>;
	readMoreText: string | null;
	className?: string;
}

export const HeaderDescription: FC<Props> = ({ description, readMoreText, readMoreRef, className }) => {
	const { classes, cx } = useStyles();

	const onClickReadMore = useCallback(() => {
		if (window && window.scrollTo && readMoreRef) {
			window.scrollTo({
				top: readMoreRef?.current?.offsetTop,
				behavior: 'smooth',
			});
		}
	}, [readMoreRef]);

	return (
		<div className={cx(classes.descriptionContainer, className)}>
			<Typography variant="bodyMd" as="p" className={classes.description}>
				{description}
			</Typography>
			{readMoreText && (
				<Link className={classes.readMoreButton} onClick={onClickReadMore}>
					{readMoreText}
				</Link>
			)}
		</div>
	);
};
